<template>
  <div
    class="date-row date-time">
    <div>
      <div class="date-row__label">
        {{ $t('Tenders.Date') }}
      </div>
      <DateMenu
        :value="valueMutable.fullDate"
        with_allowed_dates
        @update:value="val => sendValues('date', val)"/>
    </div>
    <div>
      <div class="date-row__label">
        {{ $t('Tenders.Time') }}
      </div>
      <TimeMenu
        class_name="ml-0"
        :day="false"
        :disabled="disabled"
        max="18:00:00"
        min="09:00:00"
        :second="false"
        :time="valueMutable.time"
        @update:time="val => sendValues('time', val)"/>
    </div>
  </div>
</template>
<script>
import DateMenu from 'components/common/inputs/DateMenu.vue'
import TimeMenu from 'components/common/inputs/TimeMenu.vue'

export default {
  name: 'automationActionDateTime',
  methods: {
    sendValues(key, props) {
      const result = this.$_.cloneDeep(this.valueMutable)
      result[key] = props

      const resultObject = {
        UpdateDateType: this.value?.UpdateDateType,
        NeedOverrideTime: result.check,
        UpdateValue: `${result.date || ''}T${result.time || '00:00:00'}`
      }

      this.$emit('update:value', JSON.stringify(resultObject))
    }
  },
  computed: {
    valueMutable() {
      const defaultValue = {
        date: null,
        time: null,
      }
      if (!this.value?.UpdateValue?.trim()) {
        return defaultValue
      }

      const result = this.value?.UpdateValue.split('T')
      if (!result || result.length !== 2) {
        return defaultValue
      }
      return {
        fullDate: this.value?.UpdateValue,
        date: result[0],
        time: result[1],
      }
    }
  },
  components: {
    DateMenu,
    TimeMenu
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
  },
}
</script>
<style scoped lang="scss">
.date-row {
  margin-top: 10px;
  display: grid;
  &__label {
    min-height: 16px;
    margin-bottom: 4px;
    display: flex;
    font-size: 0.75rem;
  }
  &.date-time {
    grid-template-columns: 200px 200px;
  }
}

</style>
